import Vue       from 'vue'
import Router    from 'vue-router'
import CastNew      from '@/components/CastNew'
import Dropzone     from '@/components/caster/Dropzone'
import PropsForm    from '@/components/caster/PropsForm'
import CastLauncher from '@/components/caster/CastLauncher'
import CastResult   from '@/components/caster/CastResult'
import About        from '@/components/About'
import HowTo        from '@/components/HowTo'
import CheckCast    from '@/components/CheckCast'
import Donate       from '@/components/Donate'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'CastNew',
      component: CastNew,
      children: [
        {
          path: '/',
          name: 'Dropzone',
          component: Dropzone,
        },
        {
          path: '/new',
          name: 'New',
          component: PropsForm,
        },
        {
          path: '/cast',
          name: 'Cast',
          component: CastLauncher,
        },
        {
          path: '/result',
          name: 'Result',
          component: CastResult,
        }
      ]
    }
  , {
      path: '/about',
      name: 'About',
      component: About
    }
  , {
      path: '/how-to',
      name: 'HowTo',
      component: HowTo
    }
  , {
      path: '/check',
      name: 'CheckCast',
      component: CheckCast
    }
  , {
      path: '/donate',
      name: 'Donate',
      component: Donate
    }
  , {
      path: '*',
      redirect: 'CastNew',
    }
  ]
, mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js